"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../index");

var _index2 = require("../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _social_styles = _interopRequireDefault(require("./social_styles"));

var _social_definition = _interopRequireDefault(require("./social_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// utils
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : SOCIAL ICONs ~~~~~~~~~~ ========== */


var SocialLinks = (0, _reactJss.default)(_social_styles.default)(function (props) {
  return _react.default.createElement("div", {
    className: "social ".concat(props.classes.social)
  }, _react.default.createElement("p", {
    className: "message"
  }, "Meanwhile, follow us:"), _react.default.createElement(_index.Link, {
    name: "facebook",
    type: "external",
    action: _index2.url.social.facebook
  }, _react.default.createElement(_index.Icon, {
    name: "facebook-square",
    style: "fab"
  })), _react.default.createElement(_index.Link, {
    name: "twitter",
    type: "external",
    action: _index2.url.social.twitter
  }, _react.default.createElement(_index.Icon, {
    name: "twitter",
    style: "fab"
  })), _react.default.createElement(_index.Link, {
    name: "linkedin",
    type: "external",
    action: _index2.url.social.linkedin
  }, _react.default.createElement(_index.Icon, {
    name: "linkedin-in",
    style: "fab"
  })));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(SocialLinks, _social_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = SocialLinks;
exports.default = _default;